import { Component, ViewChildren } from '@angular/core';
import { AbstractComponent } from '../abstract/abstract.component';
import { ChildComponent } from '../child/child.component';
import { AbstractControl, FormArray, FormControl, FormGroup } from '@angular/forms';

@Component({
  providers: [],
  template: '',
})
export class ParentComponent extends AbstractComponent {
  @ViewChildren(ChildComponent) children?: ChildComponent[];

  increaseDecreaseInput(event: KeyboardEvent): void {
    const inputValue = (event.target as HTMLInputElement).value;

    // Check if '0' is the first character
    if (inputValue.length === 0 && event.key === '0' && event.code !== 'Backspace' && event.code !== 'Delete') {
      event.preventDefault();
    }

    // Allow only numeric input
    const isNumericInput = /^[0-9]*$/.test(event.key);

    if (!isNumericInput && event.code !== 'Backspace' && event.code !== 'Delete') {
      event.preventDefault();
    }
  }

  moneyInput(event: KeyboardEvent): void {
    const input = event.target as HTMLInputElement;
    const inputValue = input.value;
    const key = event.key;

    const isCtrlOrCmd = event.ctrlKey || event.metaKey;

    // Allow all Ctrl/Cmd combos like Ctrl+A, Ctrl+C, etc.
    if (isCtrlOrCmd) return;

    // Allow navigation/control keys
    const allowedKeys = [
      'Backspace',
      'Delete',
      'ArrowLeft',
      'ArrowRight',
      'Tab',
    ];
    if (allowedKeys.includes(key)) return;

    const isDigit = /^[0-9]$/.test(key);
    const isDot = key === '.';

    if (isDot) {
      // Only allow a single dot
      if (inputValue.includes('.')) {
        event.preventDefault();
      }
      return;
    }

    if (!isDigit) {
      event.preventDefault();
      return;
    }

    // Prevent multiple leading zeros (e.g. '00') but allow '0.' for decimals like 0.9
    if (inputValue === '0' && key === '0') {
      event.preventDefault();
      return;
    }

    // Limit to 2 decimal places
    if (inputValue.includes('.')) {
      const decimalPart = inputValue.split('.')[1];
      if (decimalPart && decimalPart.length >= 2) {
        event.preventDefault();
      }
    }
  }

  hasInvalidControls(control: AbstractControl): boolean {
    if (control instanceof FormControl) {
      return control.invalid;
    } else if (control instanceof FormGroup) {
      return Object.keys(control.controls).some((key) => this.hasInvalidControls(control.get(key)!));
    } else if (control instanceof FormArray) {
      return control.controls.some((ctrl) => this.hasInvalidControls(ctrl));
    }
    return false;
  }
}
